var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"artwork-dropzone row align-items-center",class:_vm.slim && 'slim',attrs:{"id":`artwork_dropzone-${_vm.dz_index}`}},[_c('div',{staticClass:"d-none preview dropzone-previews"}),_vm._v(" "),_c('span',{staticClass:"icon"},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }